import PatientSocialNameInfoIcon from '@/components/patient-social-name-info-icon/index.vue'
import { resolvePatientDisplayNames } from '@/shared/utils/patient-name.helper'

export default {
  name: 'patient-name-cell',
  components: {
    PatientSocialNameInfoIcon
  },
  props: {
    patientName: {
      type: String,
      required: true
    },
    socialName: {
      type: String,
      default: null
    }
  },
  computed: {
    displayNames () {
      return resolvePatientDisplayNames({
        patientName: this.patientName,
        socialName: this.socialName
      })
    },
    hasSocialName () {
      return this.displayNames.hasSocialName
    },
    primaryName () {
      return this.displayNames.primaryName
    },
    truncatedCivilName () {
      return this.displayNames.truncatedCivilName
    },
    fullPrimaryName () {
      return this.hasSocialName ? this.displayNames.normalizedSocialName : (this.patientName || '')
    }
  }
}
